module.exports = __webpack_public_path__ + "static/media/icon-rocket.4477566a.svg";